import * as analytics from 'analytics/Analytics';
import {Sequence} from 'components/Sequence';
import {MOLBIO_ANALYTICS_ACTIONS} from 'constants/analytics-products';
import Protein from 'molbio/aa-sequences/AaSequence';
import HistoryTabState, {HistoryTabStateAttributes} from 'molbio/visual-history/HistoryTabState';
import {TabStateDefaults} from 'Navigation';

interface AssemblyHistoryTabStateAttributes<Polymer extends Sequence | Protein>
  extends HistoryTabStateAttributes<Polymer> {}

interface AssemblyHistoryTabState<Polymer extends Sequence | Protein> {
  get<K extends keyof AssemblyHistoryTabStateAttributes<Polymer>>(
    key: K
  ): AssemblyHistoryTabStateAttributes<Polymer>[K];
  set<K extends keyof AssemblyHistoryTabStateAttributes<Polymer>>(
    attributeName: K,
    value: AssemblyHistoryTabStateAttributes<Polymer>[K],
    options?: Backbone.ModelSetOptions
  ): AssemblyHistoryTabState<Polymer>;
  set(obj: Partial<AssemblyHistoryTabStateAttributes<Polymer>>): AssemblyHistoryTabState<Polymer>;
}

class AssemblyHistoryTabState<Polymer extends Sequence | Protein> extends HistoryTabState<Polymer> {
  override onClick(): void {
    super.onClick();
    analytics.trackEvent(MOLBIO_ANALYTICS_ACTIONS.CLICKED_ASSEMBLY_HISTORY_TAB, {
      polymerId: this.polymer().id,
    });
  }

  override defaults(): TabStateDefaults {
    return {
      ...super.defaults(),
      title: 'Assembly history',
      closeable: false,
      preferenceKey: 'assembly-history',
    };
  }
}

export default AssemblyHistoryTabState;
